import React from "react";

import { MdMenu } from "react-icons/md";

import { Box, Text, Flex, Tooltip, Icon } from "@chakra-ui/react";
import Search from "./search";
import { observer } from "mobx-react-lite";
import { helperInfo } from "@uidaholib/shared/models/ui/ui";

const Header = observer(({ title, onOpen }) => {
  const isOpen = helperInfo.isOpen;
  return (
    <>
      <Box bg="white" p={2} mb={3} boxShadow="sm" borderRadius="lg">
        <Flex alignItems="center" mb={3}>
          <Box>
            <Icon as={MdMenu} mr={2} boxSize={6} onClick={onOpen} />
          </Box>
          <Text fontSize="sm" fontWeight="bold" textTransform="uppercase">
            {title}
          </Text>
        </Flex>
        <Tooltip zIndex={100} label="Search" hasArrow isOpen={isOpen}>
          <Box>
            <Search />
          </Box>
        </Tooltip>
      </Box>
    </>
  );
});

export default Header;
